// Clases de una línea de esqueleto de carga (UX-LOAD-01). Fuente única del ancho, el alto y
// el espaciado: ninguna pantalla usa estilos en línea para esto. La escala vive en
// `styles/chrome.css` (`.sk-w-*`, `.sk-h-*`, `.sk-my`, `.sk-mt`).

/** Ancho relativo al contenedor (porcentaje de la escala) o fijo para rótulos cortos. */
export type SkeletonWidth = 25 | 40 | 50 | 60 | 70 | 80 | 90 | 100 | 'xs' | 'sm' | 'md' | 'lg';

/** Alto: `sm` texto chico, `md` título, `field` campo de formulario, `block` bloque o tarjeta. */
export type SkeletonHeight = 'sm' | 'md' | 'field' | 'block';

/** Espaciado: `y` arriba y abajo (filas sueltas), `top` solo arriba (segunda línea). */
export type SkeletonSpace = 'y' | 'top';

export interface SkeletonLineOptions {
  width?: SkeletonWidth;
  height?: SkeletonHeight;
  space?: SkeletonSpace;
}

/** Anchos alternados para filas repetidas: la carga imita texto de largo variable. */
export const SKELETON_CYCLE: readonly SkeletonWidth[] = [90, 70, 80, 60];

const SPACE: Readonly<Record<SkeletonSpace, string>> = { y: 'sk-my', top: 'sk-mt' };

export function skeletonLine(opts: SkeletonLineOptions = {}, extra?: string): string {
  const parts = ['skeleton-line'];
  if (opts.width !== undefined) {
    parts.push(`sk-w-${opts.width}`);
  }
  if (opts.height !== undefined) {
    parts.push(`sk-h-${opts.height}`);
  }
  if (opts.space !== undefined) {
    parts.push(SPACE[opts.space]);
  }
  if (extra !== undefined) {
    parts.push(extra);
  }
  return parts.join(' ');
}
